module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring.3cc0a24.webp";